import http from 'utils/http';

export const checkExistDispatcher = (id, organizationId) =>
  http.get(`v1/orders/${id}/dispatcher-job/?organization_id=${organizationId}`);

export const createDispatcherJob = ({ id, organizationId }) => http.post(`v1/orders/${id}/dispatcher-job/`, { organization_id: organizationId }).then((res) => res.data);

export const changeOrderState = ({ orderId, state }) => http.post(`v1/orders/${orderId}/state`, { state }).then((res) => res.data);
